import { useState as c, useEffect as o } from "react";
function p(e, { initialValue: s = !1, closeOnEscape: a = !0 } = {}) {
  const [t, r] = c(s);
  return o(() => {
    function u(n) {
      n.code === "Escape" && (n.preventDefault(), n.stopPropagation(), a && r(!1));
    }
    return e.current?.addEventListener("keydown", u), () => e.current?.removeEventListener?.("keydown", u);
  }, []), o(() => {
    t ? e.current?.showModal() : e.current?.close();
  }, [t]), /** @type {const} */
  [t, r];
}
export {
  p as default
};
